import { render } from "./section-3.vue?vue&type=template&id=60163131"
import script from "./section-3.vue?vue&type=script&lang=js"
export * from "./section-3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__